'use client'

import DisablePrefetchLink from '@component/disablePrefetchLink'
import ImageBgLoading from '@component/imageBgLoading'
import SectionLayout from '@component/layout/section'
import { LIVING_OPTIONS, LIVING_OPTIONS_LABEL } from '@config'
import getHouseRoute from '@plugin/searchRoute/modules/house'
import { getHouseId } from '@utils/house'
import { find, first, get, map, size } from 'lodash-es'
import { useMemo, useState } from 'react'
import HouseLivingOptionsContext from './context'
import HouseLivingOptionsTabs from './tabs'
import { houseList } from '@router'
import { houseSearchType } from '@routerConfig'
import { getSlug } from '@utils'

export default function LivingOptionsContent({
  data
}) {
  const tabs = useMemo(() => map(data.availableLivingOptions, (item) => ({ label: LIVING_OPTIONS_LABEL[item.type], value: item.type })), [data.availableLivingOptions])
  const [tab, setTab] = useState(first(tabs))

  if (!size(data.availableLivingOptions)) {
    return null
  }

  return (
    <HouseLivingOptionsContext.Provider value={{ tab, setTab, tabs }}>
      <SectionLayout title='Living options' titleRight={<HouseLivingOptionsTabs></HouseLivingOptionsTabs>} contentClassName='!mt-0'>
        <div className='rounded-b-sm md:border md:p-20'>
          <LivingOptionCard data={find(get(data, 'availableLivingOptions'), item => item.type === tab.value)} house={data} />
        </div>
      </SectionLayout>
    </HouseLivingOptionsContext.Provider>
  )
}

function LivingOptionCard({
  data,
  house
}) {
  const houseRoute = getHouseRoute()
  houseRoute.village = getHouseId(house)
  houseRoute.pushNewZealand()
  houseRoute['living-options'] = [getSlug(LIVING_OPTIONS_LABEL[data.type], data.type)]

  const button = (function () {
    switch (parseInt(data.type)) {
      case LIVING_OPTIONS.independentLiving:
        return 'Available independent homes'
      case LIVING_OPTIONS.servicedApartments:
        return 'Available serviced apartments'
      case LIVING_OPTIONS.assistedLiving:
        return 'Available assisted homes'
      case LIVING_OPTIONS.specialistCareHomes:
        return 'Available special care homes'
    }
  })()

  return (
    <div className='flex flex-col-reverse gap-x-42 border px-20 py-14 gap-y-6 md:p-0 md:border-0 md:flex-row'>
      <div className='flex-1 shrink-0 flex flex-col gap-y-10 md:items-start'>
        <div className='text-xl font-medium'>{data.title}</div>
        <p className='line-clamp-6'>{data.description}</p>
        <DisablePrefetchLink href={houseList(houseSearchType.retirementLiving, houseRoute.toSlug())} target='_blank' className='button-primary-out mt-auto'>
          {button}
          <i className='icon icon-arrow-right !text-sm font-bold ml-4' />
        </DisablePrefetchLink>
      </div>
      {
        data.image && (
          <div>
            <ImageBgLoading
              src={data.image}
              width={332}
              height={210}
              alt={data.title}
              className='w-full h-full object-cover aspect-[332/210] rounded-sm'
            />
          </div>
        )
      }
    </div>
  )
}
